/**
 * Canonical reply length IDs for accounts UserProfile / brands.constants LENGTH_* .
 */

export const REPLY_LENGTH_OPTIONS = [
  {
    value: "short",
    title: "Short",
    subtitle: "2 sentences after greeting, straight to the point.",
  },
  {
    value: "medium",
    title: "Medium",
    subtitle: "1 to 2 short paragraphs, a handful of sentences each.",
  },
  {
    value: "long",
    title: "Long",
    subtitle: "2 or 3 medium paragraphs with room for nuance.",
  },
];
